import { FaExternalLinkAlt } from "react-icons/fa";

export default function LandAck() {
    return (
        <div className="section-padding flex flex-col gap-6 bg-cream" >
            <a
                className="bg-blue-light rounded-xl text-white p-6 w-fit text-xl mb-10 flex gap-2 hover:bg-blue-dark transition duration-200"
                href="my Truth and ReconciliACTION Story.pdf"
                target="_blank"
            >
                Truth and ReconciliACTION: A Collective Independence
                <FaExternalLinkAlt className="flex-shrink-0"/>
            </a>
            <h1 className="text-3xl lg:text-4xl text-slate-800 font-header font-bold" >
                Land Acknowledgement
            </h1>
            <h2 className="text-slate-800 font-body text-xl lg:text-2xl">
                Treaty 7 Territory • Calgary, Alberta, Canada
            </h2>
            <p className="text-slate-800 font-body lg:text-lg" >
                We acknowledge with gratitude and respect that our work takes place on the traditional Treaty 7 lands of the Blackfoot Confederacy (Kainai, Piikani, and Siksika), the Tsuut’ina Nation, the Îyâxe Nakoda Nations (Chiniki, Bearspaw, and Goodstoney), and the Métis Nation of Alberta, Region 3. We honor the enduring relationship between these Nations and this land, which stretches back to time immemorial.
            </p>
            <p className="text-slate-800 font-body lg:text-lg">
                This statement is more than words—it is a commitment to Truth and ReconciliACTION. It is grounded in the values of Community, Connection, and Curiosity, and it calls us to ongoing learning, listening, and intentional relationship-building as we work toward a more equitable and just shared future.
            </p>
        </div>
    );
}